export const ManageViews = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer">
        <path
          id="Vector"
          d="M13.75 1.75H2.25C1.97344 1.75 1.75 1.97344 1.75 2.25V13.75C1.75 14.0266 1.97344 14.25 2.25 14.25H13.75C14.0266 14.25 14.25 14.0266 14.25 13.75V2.25C14.25 1.97344 14.0266 1.75 13.75 1.75ZM2.875 2.875H5V13.125H2.875V2.875ZM13.125 13.125H6V6H13.125V13.125ZM6 5V2.875H13.125V5H6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
